import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import PaymentBadge from "@molecules/ObjectCard/Attributes/AttributeBadges/PaymentBadge/PaymentBadge"

import { BillPaymentBadgeProps } from "./BillPaymentBadge.types"

// Binary paid/unpaid indicator (not tracking actual payments). Only rendered for
// bills in a billable lifecycle — Paid, Outstanding, or Overdue.
export default function BillPaymentBadge(props: BillPaymentBadgeProps) {
    const { status, isOverdue, amount, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    const numericAmount = Number(amount)
    const formattedAmount = formatCurrency(numericAmount)

    if (status === "Paid") {
        const tooltip = numericAmount === 0 ? "Paid\nZero-total bill" : `Paid\n${formattedAmount}`
        return (
            <PaymentBadge level="full" size={size} tooltip={tooltip}>
                Paid
            </PaymentBadge>
        )
    }

    if (status === "Outstanding" || status === "Overdue") {
        return (
            <PaymentBadge level="none" isEscalated={isOverdue} size={size} tooltip={`Required\n${formattedAmount}`}>
                Unpaid
            </PaymentBadge>
        )
    }

    return null
}
